export interface DrivingSchool {
  code: string;
  domains: string[];
  name: string;
  shortName: string;
  logoPath: string;
  logoAlt: string;
  heroImagePath: string;
  heroImageAlt: string;
  addressLine: string;
  postalCode: string;
  city: string;
  phoneDisplay: string;
  phoneLink: string;
  approvalNumber: string;
}

export interface DrivingSchoolFormula {
  id: string;
  label: string;
  subtitle: string;
  price: number;
  features: string[];
}

export const DRIVING_SCHOOL_FORMULAS: Record<string, DrivingSchoolFormula[]> = {
  SAM: [
    {
      id: '52',
      label: 'Permis B 20h',
      subtitle: 'Boîte manuelle',
      price: 1209,
      features: [
        'Frais de gestion',
        'Évaluation initiale',
        'Séance de code en agence',
        'Séance de code en ligne',
        '20h de conduite',
        '1 examen code',
        '1 examen conduite'
      ]
    },
    {
      id: '53',
      label: 'Permis B 13h',
      subtitle: 'Boîte automatique',
      price: 1209,
      features: [
        'Frais de gestion',
        'Évaluation initiale',
        'Séance de code en agence',
        'Séance de code en ligne',
        '13h de conduite',
        '1 examen code',
        '1 examen conduite'
      ]
    },
    {
      id: '51',
      label: 'AAC 20h',
      subtitle: 'Conduite accompagnée manuelle',
      price: 1449,
      features: [
        'Frais de gestion',
        'Évaluation initiale',
        'Séance de code en agence',
        'Séance de code en ligne',
        '20h de conduite',
        '2 RDV pédagogiques',
        '1 examen code',
        '1 examen conduite'
      ]
    }
  ],
  NORD: [
    {
      id: '93',
      label: 'Permis B 20h',
      subtitle: 'Boîte manuelle',
      price: 1179,
      features: [
        'Frais de gestion',
        'Évaluation initiale',
        'Séance de code en agence',
        'Séance de code en ligne',
        '20h de conduite',
        '1 examen code',
        '1 examen conduite'
      ]
    },
    {
      id: '99',
      label: 'Permis B 13h',
      subtitle: 'Boîte automatique',
      price: 1179,
      features: [
        'Frais de gestion',
        'Évaluation initiale',
        'Séance de code en agence',
        'Séance de code en ligne',
        '13h de conduite',
        '1 examen code',
        '1 examen conduite'
      ]
    },
    {
      id: '100',
      label: 'AAC 20h',
      subtitle: 'Conduite accompagnée manuelle',
      price: 1549,
      features: [
        'Frais de gestion',
        'Évaluation initiale',
        'Séance de code en agence',
        'Séance de code en ligne',
        '20h de conduite',
        '2 RDV pédagogiques',
        '1 examen code',
        '1 examen conduite'
      ]
    }
  ]
};

export const DRIVING_SCHOOLS_FORMULAS = DRIVING_SCHOOL_FORMULAS;

export const DRIVING_SCHOOLS: DrivingSchool[] = [
  {
    code: 'NORD',
    domains: ['autoecoledunord.fr', 'www.autoecoledunord.fr', 'localhost'],
    name: 'Auto Ecole du Nord',
    shortName: 'Du Nord',
    logoPath: '/assets/img/baniere.png',
    logoAlt: 'Logo Auto Ecole du Nord',
    heroImagePath: '/assets/img/voiture-nord.png',
    heroImageAlt: 'Voiture de l Auto Ecole du Nord devant le beffroi',
    addressLine: '1 rue du Nord',
    postalCode: '59280',
    city: 'Armentieres',
    phoneDisplay: '09 80 71 89 32',
    phoneLink: '0980718932',
    approvalNumber: 'E21 059 000 80'
  },
  {
    code: 'SAM',
    domains: ['autoecolesam.fr', 'www.autoecolesam.fr'],
    name: 'Auto Ecole SAM',
    shortName: 'SAM',
    logoPath: '/assets/img/logo-sam.png',
    logoAlt: 'Logo Auto Ecole SAM',
    heroImagePath: '/assets/img/voiture-sam.png',
    heroImageAlt: 'Voiture de l Auto Ecole SAM',
    addressLine: '189 rue du Marechal Foch',
    postalCode: '59120',
    city: 'Loos',
    phoneDisplay: '06 25 25 44 90',
    phoneLink: '0625254490',
    approvalNumber: 'E21 059 000 80'
  }
];

export const DEFAULT_DRIVING_SCHOOL = DRIVING_SCHOOLS[0];

export function getDrivingSchoolByHostname(hostname: string): DrivingSchool {
  const normalizedHostname = hostname.toLowerCase();

  return DRIVING_SCHOOLS.find((school) =>
    school.domains.some((domain) => normalizedHostname.includes(domain.toLowerCase()))
  ) ?? DEFAULT_DRIVING_SCHOOL;
}

export function getStoreCodeByHostname(hostname: string): string {
  return getDrivingSchoolByHostname(hostname).code;
}

export function getDrivingSchoolFormulas(hostname: string): DrivingSchoolFormula[] {
  const schoolCode = getStoreCodeByHostname(hostname);

  return DRIVING_SCHOOL_FORMULAS[schoolCode] ?? DRIVING_SCHOOL_FORMULAS[DEFAULT_DRIVING_SCHOOL.code] ?? [];
}
